import { useCart } from './useCart'

export default useCart
